export const listEmptyStateIntlIds = {
  title: 'listEmptyStateIntlIds.title',
  description: 'listEmptyStateIntlIds.description',

  filteredList: {
    title: 'listEmptyStateIntlIds.filteredList.title',
    description: 'listEmptyStateIntlIds.filteredList.description',
    clearFiltersButton: {
      label: 'listEmptyStateIntlIds.filteredList.clearFiltersButton.label',
    },
  },
};
